const BMC_URL = 'https://www.buymeacoffee.com/pixelutility';

export default function BuyMeACoffeeButton() {
  return (
    <a
      href={BMC_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex h-11 flex-1 items-center justify-center gap-2 rounded-xl bg-[#FFDD00] px-5 text-sm font-normal text-black shadow-sm transition hover:brightness-95 sm:min-w-[160px] sm:flex-none"
      style={{ fontFamily: '"Cookie", cursive' }}
    >
      <img
        src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
        alt=""
        width={16}
        height={16}
        className="h-4 w-4 shrink-0"
      />
      Buy me a coffee
    </a>
  );
}
